import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import styles from "../TransparentDrawer.module.scss";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { useNavigate, useParams } from "react-router-dom";

function LeaveTip() {
  const { t } = useTranslation();
  const { selectedAmount, tipAmount } = useVenuesDataStore();

  const total = selectedAmount + tipAmount;
  const { restaurantId, tableId } = useParams();
  const navigate = useNavigate();

  return (
    <div className={styles.selectedSplitTheBillWrapper}>
      <div className={styles.selectedSplitTheBillHeader}>
        <p className={`body-bold-medium ${styles.selectedSplitTheBillTitle}`}>
          {t("transparentDrawer.title.youArePayingInTotal")}
        </p>
        <p className={`body-medium ${styles.selectedSplitTheBillPrice}`}>
          {total.toFixed(2)} zł
        </p>
      </div>
      <Button
        onClick={() =>
          navigate(
            `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill/confirm-and-pay`,
          )
        }
        label={t("transparentDrawer.button.selectPaymentMethod")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
      />
    </div>
  );
}

export default LeaveTip;
